export const SET_ORDER                    = 'SET_ORDER';
export const GET_REQUESTED_GATEWAYS_ORDER = 'GET_REQUESTED_GATEWAYS_ORDER';
export const GET_GATEWAYS_ORDER_SUCCESS   = 'GET_GATEWAYS_ORDER_SUCCESS';
export const GET_GATEWAYS_ORDER_FAILED    = 'GET_GATEWAYS_ORDER_FAILED';
export const SET_GATEWAY_TOKEN            = 'SET_GATEWAY_TOKEN';
